const common = {
    no_data: 'Không có dữ liệu',
    header: {
        business_name: 'Doanh nghiệp của bạn'
    },
    download_app: {
        text: 'Để sử dụng phiên bản web Simply, vui lòng sử dụng laptop hoặc PC.',
        button: 'Tải phiên bản di động'
    },
    unknown: 'Không xác định',
    request_error: 'Đã xảy ra lỗi. Vui lòng thử lại! Hoặc liên hệ bộ phận hỗ trợ khách hàng để báo cáo vấn đề.',
    home: 'Trang chủ',
    dashboard: 'Bảng điều khiển',
    product: 'Sản phẩm',
    add_product: 'Thêm sản phẩm',
    edit_product: 'Sửa sản phẩm',
    stock_in: 'Nhập kho',
    Sales_Turnover: 'Doanh thu bán hàng',
    profit: 'Lợi nhuận',
    stock_out: 'Xuất kho',
    staff: 'Nhân viên',
    stock_audit: 'Kiểm kê kho',
    button: {
        save: 'Lưu',
        save_and_add_more: 'Lưu & Thêm tiếp',
        submit: 'Xác nhận',
        done: 'Hoàn tất',
        edit: 'Sửa',
        save_edit: 'Lưu thay đổi',
        yes: 'Có',
        clear: 'Xóa',
        delete: 'Xóa',
        cancel: 'Hủy',
        reset: 'Đặt lại'
    },
    select_date: 'Chọn ngày',
    select_action: 'Chọn hành động',
    mandatory: ' *(Bắt buộc)',
    not_mandatory: '(Không bắt buộc)',
    business: 'Doanh nghiệp',
    account: 'Tài khoản',
    profile: 'Hồ sơ',
    setting: 'Cài đặt',
    whichLanguage: 'Tiếng Việt',
    headerDashboard: 'Trở thành VIP',
    contact_us: 'Liên hệ chúng tôi',
    logout: 'Đăng xuất',
    category: 'Danh mục',
    add_category: 'Thêm danh mục',
    data: 'Dữ liệu',
    history: 'Lịch sử',
    lowStockAlert: 'Cảnh báo tồn kho thấp',
    Expenses: 'Chi phí',
    lowStockAlertButton: 'Thêm số lượng tồn kho an toàn',
    message: {
        login_success: 'Đăng nhập thành công!',
        onboard_success: 'Hoan hô!! Hành trình của bạn đã bắt đầu!',
        successfully_saved: 'Lưu dữ liệu thành công',
        successfully_deleted: 'Xóa dữ liệu thành công',
        error_required_field: 'Trường bắt buộc không được để trống',
        no_access: 'Không có quyền truy cập',
        no_permission: 'Bạn không có quyền',
        error_update_history: 'Cập nhật lịch sử thất bại'
    },
    no_permission_dialog: {
        title: 'Không có quyền',
        description: 'Bạn không có quyền xem Chi phí. Vui lòng liên hệ quản trị viên.'
    },
    feedback: 'Gửi phản hồi',
    contact: 'Liên hệ',
    add: 'Thêm',
    supplier: 'Nhà cung cấp',
    customer: 'Khách hàng',
    random: 'Ngẫu nhiên',
    scan: 'Quét',
    enter: 'Đăng nhập bằng cách quét mã vạch',
    terms: {
        text: 'Tiếp tục tức là bạn đồng ý với',
        link: 'Chính sách bảo mật'
    },
    others: 'Khác',
    calender: {
        presets: {
            today: 'Hôm nay',
            yesterday: 'Hôm qua',
            last_7_days: '7 ngày qua',
            last_30_days: '30 ngày qua',
            this_month: 'Tháng này',
            last_month: 'Tháng trước',
            custom_range: 'Tùy chỉnh'
        }
    },
    print_large: 'In lớn (A4)',
    print_letter: 'In Letter (US)',
    print_dot_matrix: 'In lớn (Máy in kim)',
    print_medium: 'In trung bình (75mm)',
    print_small: 'In nhỏ (48mm)',
    format: 'Định dạng giấy',
    preview: 'Xem trước',
    view_invoice: 'Hóa đơn',
    view_chalan: 'Phiếu xuất kho',
    price: 'Giá',
    stock: 'Tồn kho',
    quantity: 'Số lượng',
    total: 'Tổng cộng',
    print_footer_left: 'Tạo bởi',
    print_footer_center: 'In lúc',
    print_footer_date: 'vào ngày',
    print_to: 'Đến',
    language: 'Tiếng Việt',
    dateStatus: '7 ngày qua',
    placeholder: 'Loại giao dịch',
    staffHistory: 'Chọn nhân viên',
    languageTitle: 'Tiếng Việt',
    date: 'Ngày',
    download: 'Tải xuống',
    download_excel: 'Tải Excel',
    download_pdf: 'Tải mã vạch',
    currentTitle: 'Tiền tệ',
    Selectperiod: 'Chọn khoảng thời gian',
    TransactionType: 'Loại giao dịch',
    SelectCustomer: 'Chọn khách hàng',
    invoice: 'Hóa đơn',
    login: {
        google: 'Đăng nhập bằng Google',
        apple: 'Đăng nhập bằng Apple'
    },
    trusted_by: {
        title: 'Được hơn 50.000 doanh nghiệp tin dùng \n trên khắp Indonesia 🇮🇩'
    },
    privacyPolicyOne: "Khi đăng nhập, bạn đồng ý với",
    privacyPolicyTwo: 'Chính sách bảo mật',
    manufacture: 'Sản xuất',
    warehouse: 'Kho hàng',
    error: {
        title: 'Ối! Đã xảy ra lỗi',
        description: 'Đã xảy ra lỗi không mong muốn. Vui lòng làm mới trang hoặc quay về trang chủ.',
        refresh: 'Làm mới trang',
        go_back: 'Quay về trang chủ',
        not_found: 'Không thấy trang'
    },
    totalPurchasePrice: 'Tổng giá mua',
    pageTotalPurchaseAmount: 'Tổng số tiền mua theo trang',
    approval_status: 'Trạng thái phê duyệt',
    pending: 'Đang chờ xử lý',
    approved: 'Đã phê duyệt',
    rejected: 'Đã từ chối',
    select_fields: 'Chọn lĩnh vực',
    syncWithTally: 'Đồng bộ với Tally',
    importFromTally: 'Nhập từ Tally',
    exportToTally: 'Xuất sang Tally',
    All: 'Tất cả',
    Approval: 'Phê duyệt'
}
export default common